import { render, staticRenderFns } from "./SyncPage.vue?vue&type=template&id=5dce2f51&scoped=true&"
import script from "./SyncPage.vue?vue&type=script&lang=js&"
export * from "./SyncPage.vue?vue&type=script&lang=js&"
import style0 from "./SyncPage.vue?vue&type=style&index=0&id=5dce2f51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dce2f51",
  null
  
)

export default component.exports